var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      ref: "menu1",
      attrs: {
        "offset-y": "",
        "close-on-content-click": false,
        "nudge-right": 40,
        transition: "scale-transition",
        "max-width": "290px",
        "min-width": "290px",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    attrs: {
                      label: _vm.textBoxLabel,
                      clearable: _vm.clearable,
                      "hide-details": _vm.hide_details,
                      "persistent-hint": "",
                      "prepend-icon": "mdi-calendar",
                      readonly: "",
                    },
                    on: { "click:clear": _vm.clear },
                    model: {
                      value: _vm.dateFormatted,
                      callback: function ($$v) {
                        _vm.dateFormatted = $$v
                      },
                      expression: "dateFormatted",
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu1,
        callback: function ($$v) {
          _vm.menu1 = $$v
        },
        expression: "menu1",
      },
    },
    [
      _c("v-date-picker", {
        attrs: { "no-title": "" },
        on: {
          input: function ($event) {
            _vm.menu1 = false
          },
        },
        model: {
          value: _vm.internalDate,
          callback: function ($$v) {
            _vm.internalDate = $$v
          },
          expression: "internalDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }